<script>
	const model = require('model/model');
	const utilities = require('utilities');

	module.exports = {
		components: {
			modal: require('components/modal.vue').default
		},
		modelData: ['hasDownloadedAnAssignment'],
		data() {
			return {
				loading: false
			};
		},
		methods: {
			onOkClick() {
				model.set('hasDownloadedAnAssignment', true);
				utilities.closeModals();
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	#modal-download-assignment {
	}
</style>
<template>
	<modal
		ref="modal"
		id="modal-download-assignment"
		:ok="false"
		:centered="true"
		:loading="loading">
		<template slot="header-container">
			<h2>You downloaded an assignment</h2>
		</template>
		<div
			slot="content"
			class="modal-disable-offline">
			<p>
				You can access and complete all downloaded assignments without a connection to the internet by switching your account to offline mode. See how to
				use offline mode
				<outbound-link
					data-outbound-link="DOWNLOAD_ASSIGNMENT_MODAL"
					target="_blank"
					href="https://about.readworks.org/offline-mode.html">
					here.
				</outbound-link>
			</p>
			<p>
				<button
					class="button"
					@click="onOkClick">
					Ok
				</button>
			</p>
		</div>
	</modal>
</template>
